import React, { useEffect, useState, useMemo, useRef, createRef } from 'react';
import { HOMEPOPUP_DATA, DOMURL, HLSJSVERSION } from '../../url';
import axios from 'axios';
import $ from 'jquery'
import OwlCarousel from 'react-owl-carousel';
import Player from '../Player/Player.jsx'
import Loader from '../../component/loader/home_loading';
import { Link } from "react-router-dom";

const PreHomePopUp = () => {
  let isAuth = localStorage.getItem('userid')
  const ammabxWdht = useRef(null);
  const [prehomecarouselData, setprehomecarouselData] = useState([]);
  const [prehomeObject, setprehomecObject] = useState({});
  const [isLoading, setisLoading] = useState(true)
  const popup_sldr_itm = {
    320: { items: 1, margin: 0 },
    480: { items: 1, margin: 0 },
    600: { items: 2, margin: 10 },
    860: { items: 3, margin: 10 },
    1600: { items: 3, margin: 10 },
    2000: { items: 3, margin: 10 }
  }
  const [playing, setPlaying] = useState(true)
  useEffect(() => {
    // if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
    //   alert( "This page is reloaded" );
    // } else {
    //   alert( "This page is not reloaded");
    // }
    document.body.classList.add('overflow-hidden');
    async function fetchPreHomeCarouselData() {
      let formData = new FormData();
      formData.append('img_type', "w");
      let response = await axios.post(HOMEPOPUP_DATA, formData, { headers: { 'token': localStorage.getItem('token') } });
      if (response.status === 200) {
        let preHomeObj = response.data
        let preHomepPopupData = response.data.pre_home
        setprehomecObject(preHomeObj);
        setprehomecarouselData(preHomepPopupData);
        setisLoading(false);
      }
      else {
        let msg = response.data.message;
        $('#snackbar .msg').html(msg);
        $('#snackbar').addClass('show').addClass('bg-danger').removeClass('bg-success');
        setTimeout(function () {
          $('#snackbar').removeClass('show');
          // localStorage.clear();
          // window.location.href = "/"
        }, 2000);
      }
    }
    fetchPreHomeCarouselData();
    
  }, []);
  
  const startPosition = useRef(null);
  const imagesarrids = []
  const refsByImage = useMemo(() => {
    const refs = {}
    prehomecarouselData.map((data, key) => {
      if (data.slider_type === "V") {
        imagesarrids.push(key)
        refs[key] = React.createRef(null)
      }
    })
    return refs
  }, [prehomecarouselData,imagesarrids])
  const refsByVideo = useMemo(() => {
    const refs = {}
    prehomecarouselData !== undefined && prehomecarouselData !== null && prehomecarouselData.length > 0 && prehomecarouselData.map((data, key) => {
      if (data.slider_type !== null && data.slider_type !== undefined &&  data.slider_type === "V") {
        refs[key] = React.createRef(null)
      }
    })
    return refs
  }, [prehomecarouselData])
  const refsByhtml5Video = useMemo(() => {
    const refs = {}
    prehomecarouselData !== undefined && prehomecarouselData !== null && prehomecarouselData.length > 0 && prehomecarouselData.map((data, key) => {
      if (data.slider_type !== null && data.slider_type !== undefined &&  data.slider_type === "V") {
        refs[key] = React.createRef(null)
      }
    })
    return refs
  }, [prehomecarouselData])
  const callback = (e) => {
    
    let CrntActv = e.currentTarget
    let selectors = '.iv'
    let CntrCls = CrntActv.querySelector('.center')  
    let getAtrbt = ammabxWdht.current.offsetWidth  
    
    if (CntrCls.querySelector(selectors)) {
      let Id = parseInt(CntrCls.querySelector(selectors).getAttribute('id').split("_")[1])
      refsByImage[Id].current.style.display= "none"
      refsByVideo[Id].current.style.display= ""      
      imagesarrids.forEach(id => {
        refsByVideo[Id].current.style.height = getAtrbt + 'px'
        //  
        if (Id === id) {
          refsByhtml5Video[Id].current.getInternalPlayer().play();
        } else {
          refsByhtml5Video[Id].current.getInternalPlayer().pause();
        }
      });
    }
    else {
      CntrCls.querySelector(selectors)
    }
  }
  const callBackonClick = (e) => {
    //  
    let CrntActv = e.currentTarget
    let selectors = '.iv'
    let CntrCls = CrntActv.querySelector('.center')
    let getAtrbt = ammabxWdht.current.offsetWidth  
    if (CntrCls.querySelector(selectors)) {
      let Id = parseInt(CntrCls.querySelector(selectors).getAttribute('id').split("_")[1])
      let i = 0;
      imagesarrids.forEach(id => {
        refsByVideo[Id].current.style.height = getAtrbt + 'px'
        refsByImage[id].current.style.display = "none"
        refsByVideo[Id].current.style.display = ""
        if (Id === id) {
          refsByImage[id].current.style.display = "none"
          refsByVideo[Id].current.style.display = ""
          let playPromise = refsByhtml5Video[id].current.getInternalPlayer().play();
          if (playPromise !== undefined) {
            playPromise.then(_ => {
              playPromise.pause();
            })
              .catch(error => {
                refsByhtml5Video[id].current.getInternalPlayer().play()
              });
          } else {
            refsByhtml5Video[id].current.getInternalPlayer().play()
          }
        } else {
          refsByhtml5Video[id].current.getInternalPlayer().pause();
          refsByImage[Id].current.style.display = "none"
          refsByVideo[Id].current.style.display = ""
        }
        i++
      });
    }
    else {
      
      //document.querySelectorAll('video').forEach(vid => vid.pause());
      imagesarrids.forEach(id => {
        
        refsByhtml5Video[id].current.getInternalPlayer().pause();
        refsByImage[id].current.style.display = ""
        refsByVideo[id].current.style.display = "none"
      });
      CntrCls.querySelector(selectors)
    }
  }
  document.addEventListener('keydown', function(event){
    if(event.key === "Escape"){
      imagesarrids.forEach(id => {
        refsByhtml5Video[id].current.getInternalPlayer().pause();
      });
      let elem = document.querySelector(".amrt-lve-popup-wppr");
      let elemnt2 = document.querySelector(".amrt-lve-popup-cntct-wppr");
      let Clsbtn = document.querySelector(".cls-popup-btn");
      elem.style.visibility = "hidden";
      elem.style.width = "0px";
      elemnt2.style.opacity = "0"
      elemnt2.style.visibility = "hidden"
      Clsbtn.style.display = "none"
    }
  });
  const ClspopUp = (el) => {
    localStorage.setItem('popup','false')
    document.body.classList.remove('overflow-hidden');
    imagesarrids.forEach(id => {
      refsByhtml5Video[id].current.getInternalPlayer().pause();
    });
    let elem = document.querySelector(".amrt-lve-popup-wppr");
    elem.classList.add('close');
  }
  if (!isLoading) {
    return (
      <>
        {
          prehomecarouselData !== null && prehomecarouselData !== undefined && prehomecarouselData.length > 0 ?
            <div className="amrt-lve-popup-wppr d-block ">
            <span className="blk-ovrly" onClick={ClspopUp}></span>            
            <div className="amrt-lve-popup-cntct-wppr">
            <div className="popup-cls-wppr">
              <button type="button" onClick={ClspopUp} className="cls-popup-btn"></button>
            </div>
              <div className="amma-txt-wppr">
                <div className="amma-logo-wppr">
                  <span>
                    <img src={prehomeObject.logo_url} alt="" />
                  </span>
                </div>
                <div className="title">
                  <h6>{prehomeObject.title}</h6>
                  <p> {prehomeObject.sub_title} </p>
                </div>
              </div>
              <div className="amma-sldr-wppr">
                <OwlCarousel className="amma-sldr"
                  id="owl-amma"
                  loop={true}
                  mouseDrag={false}
                  touchDrag={false}
                  pullDrag={false}
                  rewind={true}
                  autoplay={false}
                  center={true}
                  dots={true}
                  nav={true}
                  navText={["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"]}
                  autoplayTimeout={500}
                  onClick={callBackonClick}
                  onLoad={callback}
                  startPosition={startPosition.current}
                  onChange={({ item, page }) => {
                    startPosition.current = item.index - page.size;
                  }}
                  smartSpeed={500}
                  responsive={popup_sldr_itm}
                >

                  {prehomecarouselData !== null && prehomecarouselData !== undefined && prehomecarouselData.length > 0 && prehomecarouselData.map((data, key) => {
                    if (data.slider_type === "V") {
                      //alert(prehomecarouselData.length)
                      if (data.cookies && data.cookies !== 'null' && data.cookies !== 'undefined') { 
                        var downloadUrlcookie =
                        "?Key-Pair-Id=" +
                        data.cookies["CloudFront-Key-Pair-Id"] +
                        "&Policy=" +
                        data.cookies["CloudFront-Policy"] +
                        "&Signature=" +
                        data.cookies["CloudFront-Signature"];
                      // alert(prehomeObject.title)
                      // alert(prehomecarouselData.length)
                      }
                    }

                    return (
                      <div className="amma-sldr-itm" key={key} ref={ammabxWdht}>
                        <div className="vido-wppr" key={key}>
                          {data.slider_type === "I" ? <span>
                            <img src={data.imgurl} alt="" />
                          </span> :
                            <>
                              <div className="iv" id={`vidowpprid_${key}`}>
                                <div className="thumb" id={`imageid_${key}`} ref={refsByImage[key]}>
                                  <img src={data.thumburl.size_1080_1080 !== undefined && data.thumburl.size_1080_1080 !== null? data.thumburl.size_1080_1080: data.thumburl.h_thumburl ? data.thumburl.h_thumburl: data.thumburl.v_thumburl ? data.thumburl.v_thumburl: data.thumburl.size_default} alt=''/>
                                  {/* <img src={data.imgurl:data.thumburl.size_default ? data.imgurl:data.thumburl.size_default} alt="" /> */}
                                </div>
                                <div className="player" id={`playerid_${key}`} style={{display: `none`}} ref={refsByVideo[key]}>
                                  {/* <iframe src={data.downloadurl} allow="autoplay">
                                    <Player playerref={refsByhtml5Video[key]} playing={true} videoUrl={data.downloadurl} downloadUrlcookie={downloadUrlcookie} cookie={data.cookies} volume={localStorage.getItem('reactplayer.volume')?localStorage.getItem('reactplayer.volume'):1} />
                                  </iframe> */}
                                  <Player playerref={refsByhtml5Video[key]} playing={playing} videoUrl={data.downloadurl} downloadUrlcookie={downloadUrlcookie} cookie={data.cookies} volume={localStorage.getItem('reactplayer.volume')?localStorage.getItem('reactplayer.volume'):1} />
                                </div>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                    )
                  })}
                </OwlCarousel>
              </div>
              {
                isAuth !== undefined && isAuth !== null && isAuth !== '' ?  '' : <div className="sbcrb-wppr">
                <div className="sbcrb-btn-wppr">
                  <Link  className="sbcrb-btn" to="/signup">Sign Up</Link>
                  <Link  className="sbcrb-btn ml-3" to="/login">Sign In</Link>
                </div>
              </div>
              }
              
            </div>
          </div>: ''
        }
      </>
    );
  } else {
    return (<Loader />)
  }

}
export default PreHomePopUp;